import { Image, Text, View } from "react-native";

import type { PublicBuylistCard } from "@/hooks/usePublicBuylist";
import { formatMoney } from "@/lib/money/money";

function Price({ label, value, atTable }: {
  label: string;
  value: string | number | null;
  atTable: boolean;
}) {
  return (
    <View className="min-w-0 flex-1 gap-1">
      <Text className="font-label text-xs text-muted-foreground">{label}</Text>
      <Text className="font-num-bold text-base text-foreground">
        {atTable ? "Price at table" : value === null ? "No online quote" : formatMoney(value)}
      </Text>
    </View>
  );
}

/** The same public card quote in a shared link and at the table. */
export function PublicBuylistCardRow({ card }: { card: PublicBuylistCard; }) {
  return (
    <View className="flex-row gap-4 border-b border-border py-4">
      {card.image_url
        ? <Image source={{ uri: card.image_url }} className="h-20 w-14 rounded-lg" />
        : <View className="h-20 w-14 rounded-lg bg-surface-muted" />}
      <View className="min-w-0 flex-1 gap-2">
        <View className="flex-row items-center gap-2">
          <Text className="min-w-0 font-title text-base text-foreground" numberOfLines={2}>
            {card.name}
          </Text>
          {card.hot
            ? <Text className="font-label text-xs text-primary">Most wanted</Text>
            : null}
        </View>
        {card.set_name || card.collector_number
          ? (
            <Text className="font-body text-xs text-muted-foreground">
              {[card.set_name, card.collector_number && `#${card.collector_number}`].filter(Boolean)
                .join(" · ")}
            </Text>
          )
          : null}
        <View className="flex-row gap-4">
          <Price label="Cash" value={card.cash} atTable={card.price_at_table} />
          <Price label="Trade" value={card.trade} atTable={card.price_at_table} />
        </View>
      </View>
    </View>
  );
}
